import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawWarningIcon from "./RawWarningIcon.svg.jsx";

const WarningIcon2 = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawWarningIcon} {...props} />;
});

export default WarningIcon2;
